var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { IconButton, OutlinedInput, SvgIcon, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-regular-svg-icons/faSearch";
import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes";
import { combineSxProps } from "../../Utils";
export const Search = (props) => {
    const { numberOfResults, onClear, sx } = props, outlinedInputProps = __rest(props, ["numberOfResults", "onClear", "sx"]);
    const endAdornment = props.value
        ? _jsxs(_Fragment, { children: [_jsxs(Typography, { variant: "helper", color: "text.secondary", children: ["(", numberOfResults, ")"] }), _jsx(IconButton, { sx: { width: "14px", height: "14px" }, onClick: onClear, "aria-label": "clear-search", children: _jsx(FontAwesomeIcon, { icon: faTimes }) })] })
        : _jsx(_Fragment, {});
    return (_jsx(OutlinedInput, Object.assign({ sx: combineSxProps(outlinedInputSxProps, sx), startAdornment: _jsx(SvgIcon, { sx: searchIconSxProps, children: _jsx(FontAwesomeIcon, { icon: faSearch }) }), endAdornment: endAdornment, placeholder: "Search..." }, outlinedInputProps)));
};
const outlinedInputSxProps = {
    display: "flex",
    gap: "8px",
    borderRadius: "16px",
    padding: "4px 12px",
    backgroundColor: theme => theme.palette.grey[200],
    ":hover:not(&.Mui-disabled)": {
        ".MuiOutlinedInput-notchedOutline": {
            borderWidth: 1
        },
        backgroundColor: theme => theme.palette.common.white
    },
    ".MuiOutlinedInput-input": {
        padding: 0
    },
    ":not(&.Mui-disabled)": {
        ".MuiOutlinedInput-notchedOutline": {
            borderWidth: 0
        },
        "&.Mui-focused": {
            backgroundColor: theme => theme.palette.common.white,
            ".MuiOutlinedInput-notchedOutline": {
                borderWidth: 1
            }
        }
    },
    "&.Mui-disabled": {
        backgroundColor: theme => theme.palette.common.white,
        ".MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${theme => theme.palette.action.disabled}`
        }
    }
};
const searchIconSxProps = {
    width: "24px",
    height: "24px",
    padding: "4px",
    fontSize: "16px",
    color: theme => theme.palette.action.active
};
//# sourceMappingURL=Search.js.map